import BackTop from 'antd/lib/back-top'

import 'antd/lib/back-top/style'

export * from 'antd/lib/back-top'

export default BackTop
